<main
  class="admin-login-root flex h-dvh max-h-dvh w-full flex-col overflow-hidden font-display text-slate-900 antialiased md:flex-row dark:text-slate-100"
>
  <section
    class="relative hidden h-full w-[42%] flex-col justify-between overflow-hidden border-slate-200/80 bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:border-slate-800/80 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 md:flex md:border-r"
  >
    <div class="admin-login-noise pointer-events-none absolute inset-0 opacity-[0.3] dark:opacity-[0.12]" aria-hidden="true"></div>
    <div class="pointer-events-none absolute -right-16 top-1/4 h-52 w-52 rounded-full bg-slate-900/5 blur-3xl dark:bg-white/5" aria-hidden="true"></div>

    <div class="relative z-10 flex h-full flex-col justify-between px-8 py-7 lg:px-10">
      <div class="flex items-center justify-between gap-3">
        <a routerLink="/" class="inline-flex" aria-label="Akalan home">
          <img src="/akalan-lockup.svg" alt="Akalan" class="h-6 w-auto opacity-90 dark:brightness-0 dark:invert" />
        </a>
        <span class="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white/80 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-600 dark:border-slate-700 dark:bg-slate-900/60 dark:text-slate-300">
          <span class="material-symbols-outlined text-[13px]">shield_person</span>
          Internal
        </span>
      </div>

      <div class="my-auto max-w-sm">
        <h2 class="text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">Admin console</h2>
        <p class="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
          Operations, support, and analytics — one secure workspace for the Akalan team.
        </p>
        <div class="mt-4 flex flex-wrap gap-2">
          <span class="rounded-full border border-slate-200 bg-white/90 px-2.5 py-1 text-[11px] font-medium text-slate-600 dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-300">RBAC</span>
          <span class="rounded-full border border-slate-200 bg-white/90 px-2.5 py-1 text-[11px] font-medium text-slate-600 dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-300">Audit trail</span>
          <span class="rounded-full border border-slate-200 bg-white/90 px-2.5 py-1 text-[11px] font-medium text-slate-600 dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-300">Session scoped</span>
        </div>
      </div>

      <p class="border-t border-slate-200/80 pt-4 text-xs text-slate-500 dark:border-slate-800 dark:text-slate-400">
        Authorized personnel only
      </p>
    </div>
  </section>

  <section class="relative flex h-full min-h-0 flex-1 flex-col justify-center overflow-hidden bg-white px-5 py-5 sm:px-8 md:px-10 dark:bg-slate-950">
    <div class="relative mx-auto flex w-full max-w-[400px] flex-col admin-login-panel-enter">
      @if (busy()) {
        <div class="admin-login-flow-veil" role="status" aria-busy="true" aria-label="Signing in to admin">
          <div class="admin-login-flow-card">
            <div class="admin-login-flow-mark" aria-hidden="true">
              <span class="material-symbols-outlined text-[20px] text-slate-700 dark:text-slate-200">shield_person</span>
            </div>
            <p class="mt-3 text-[15px] font-semibold tracking-tight text-slate-900 dark:text-white">Verifying credentials</p>
            <p class="mt-1 text-xs text-slate-500 dark:text-slate-400">Loading permissions…</p>
            <div class="admin-login-flow-progress" aria-hidden="true">
              <div class="admin-login-flow-progress-bar"></div>
            </div>
          </div>
        </div>
      }

      <div class="mb-5 flex items-center justify-between gap-3 md:hidden">
        <a routerLink="/" class="flex items-center gap-1.5 text-sm font-semibold text-slate-600 no-underline hover:text-primary dark:text-slate-400">
          <span class="material-symbols-outlined text-lg">arrow_back</span>
          Home
        </a>
        <img src="/akalan-lockup.svg" alt="Akalan" class="h-6 w-auto dark:brightness-0 dark:invert" />
      </div>

      <header class="mb-5">
        <p class="text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">Admin console</p>
        <h1 class="mt-1.5 text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">Sign in</h1>
        <p class="mt-1.5 text-[13px] text-slate-600 dark:text-slate-400">Team email and password. Access is role-gated.</p>
      </header>

      @if (error()) {
        <p
          role="alert"
          class="mb-3 flex items-start gap-2 rounded-lg border border-red-200/90 bg-red-50 px-3 py-2 text-xs text-red-900 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-100"
        >
          <span class="material-symbols-outlined mt-0.5 shrink-0 text-[16px]">error</span>
          <span>{{ error() }}</span>
        </p>
      }

      <form class="space-y-3" (ngSubmit)="submit()" novalidate>
        <div>
          <label for="admin-email" class="mb-1 block text-xs font-medium text-slate-700 dark:text-slate-300">Work email</label>
          <div class="admin-login-field flex min-h-11 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 transition dark:border-slate-700 dark:bg-slate-900">
            <span class="material-symbols-outlined text-[18px] text-slate-400" aria-hidden="true">mail</span>
            <input
              id="admin-email"
              name="email"
              type="email"
              autocomplete="username"
              class="min-h-10 flex-1 border-0 bg-transparent text-sm text-slate-900 outline-none placeholder:text-slate-400 dark:text-white"
              placeholder="you@akalan.dev"
              [ngModel]="email()"
              (ngModelChange)="email.set($event)"
              [disabled]="busy()"
              required
            />
          </div>
        </div>

        <div>
          <label for="admin-password" class="mb-1 block text-xs font-medium text-slate-700 dark:text-slate-300">Password</label>
          <div class="admin-login-field flex min-h-11 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 transition dark:border-slate-700 dark:bg-slate-900">
            <span class="material-symbols-outlined text-[18px] text-slate-400" aria-hidden="true">key</span>
            <input
              id="admin-password"
              name="password"
              [type]="showPassword() ? 'text' : 'password'"
              autocomplete="current-password"
              class="min-h-10 flex-1 border-0 bg-transparent text-sm text-slate-900 outline-none placeholder:text-slate-400 dark:text-white"
              placeholder="Enter your password"
              [ngModel]="password()"
              (ngModelChange)="password.set($event)"
              [disabled]="busy()"
              required
            />
            <button
              type="button"
              class="flex min-h-10 min-w-10 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showPassword()"
              (click)="togglePassword()"
              [disabled]="busy()"
            >
              <span class="material-symbols-outlined text-[20px]">{{ showPassword() ? 'visibility_off' : 'visibility' }}</span>
            </button>
          </div>
        </div>

        <button
          type="submit"
          class="flex min-h-11 w-full items-center justify-center gap-2 rounded-xl bg-primary text-sm font-semibold text-white transition hover:opacity-95 active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-55"
          [disabled]="busy() || !email().trim() || !password()"
        >
          @if (busy()) {
            <span class="material-symbols-outlined animate-spin text-[18px]">progress_activity</span>
            Signing in…
          } @else {
            <span class="material-symbols-outlined text-[18px]">login</span>
            Continue to console
          }
        </button>
      </form>

      <p class="mt-4 text-center text-[12px] text-slate-500 dark:text-slate-400">
        Not an admin?
        <a routerLink="/login" class="font-semibold text-primary hover:underline">Candidate sign in</a>
      </p>
    </div>
  </section>
</main>
